export default "__VITE_ASSET__B_pbugv9__"